import React, { FC } from 'react'

import { useTimerText } from 'components/block/FeaturedPhotosPromoX3/useTimerText'

export const FeaturedPhotosX3PromoTimer: FC<{
  /** Секунды */
  endDate: number
}> = ({ endDate }) => {
  const text = useTimerText(endDate)

  return <>{text}</>
}
